export default __webpack_public_path__ + "static/media/gilroy-regular.b91b0127.ttf";